import classNames from "classnames";
import "./style.scss";
interface PageTitleProps {
	title: string;
	subTitle?: string;
	noBorder?: boolean;
}

const PageTitle = ({ title, subTitle, noBorder }: PageTitleProps) => {
	return (
		<div className={classNames("page-title-wrapper", { "no-border": noBorder })}>
			<h1 className="page-title-wrapper__title">{title}</h1>
			{subTitle && <p className="page-title-wrapper__sub-title">{subTitle}</p>}
		</div>
	);
};

export default PageTitle;
